<template>
  <div class="app">
    <hidden-container
      type="overlay"

      :hide-after-milliseconds="1000"
      :default-open="true"
      position="right"
      button-text="Bekijk de ranking"
    >
      <template slot="main">
        <google-maps />

        <div class="zoom-controls">
          <controls-map-zoom />
        </div>
      </template>
      <template slot="sidebar">
        <list
          :row-clickable="true"
        />
      </template>
    </hidden-container>

    <popup
      :open="openPopup"
      :showButton=false
      @closePopup="closePopup"
    >
      <div class="popup-content">
        <div class="popup-content__facets">
          <img src="@/assets/img/inwoners.svg" class="people" />
          <facets-item
            :topic="['Inwoners']"
            :name="['Inwonersaantal']"
            type="radio"
            filter-type="RANGE"
            @filterChanged="onFilterChange"
          >
            <template slot="options">
              [
                {
                  "label": "&lt; 25.000",
                  "value": [0, 25000],
                  "selected": true
                },
                {
                  "label": "25.000 - 50.000",
                  "value": [25000, 50000],
                  "selected": false
                },
                {
                  "label": "50.000 - 100.000",
                  "value": [50000, 100000],
                  "selected": false
                },
                {
                  "label": "> 100.000",
                  "value": [100000, 20000000],
                  "selected": false
                }
              ]
            </template>
          </facets-item>
        </div>
        <div class="popup-content__years">
          <controls-year-selector />
        </div>
        <div class="popup-content__filters">
          <div class="secundairy-filter">
            <div class="secundairy-filter__container">
              <div class="secundairy-filter__inbox">
                <div class="secundairy-filter__rapport">
                  <div class="secundairy-filter__title">Rapportcijfer</div>
                  <label class="secundairy-filter__item">
                    <input
                      ref="rapport-item-1-mobile"
                      name="rapport"
                      type="checkbox"
                      @change="changeFacet('rapport', [0, 5.5], 1, 'mobile')"
                    />
                    <span>0 - 5,5</span>
                  </label>
                  <label class="secundairy-filter__item">
                    <input
                      ref="rapport-item-2-mobile"
                      name="rapport"
                      type="checkbox"
                      @change="changeFacet('rapport', [5.5, 6.5], 2, 'mobile')"
                    />
                    <span>5,5 - 6,5</span>
                  </label>
                  <label class="secundairy-filter__item">
                    <input
                      ref="rapport-item-3-mobile"
                      name="rapport"
                      type="checkbox"
                      @change="changeFacet('rapport', [6.5, 8], 3, 'mobile')"
                    />
                    <span>6,5 - 8</span>
                  </label>
                  <label class="secundairy-filter__item">
                    <input
                      ref="rapport-item-4-mobile"
                      name="rapport"
                      type="checkbox"
                      @change="changeFacet('rapport', [8, 10], 4, 'mobile')"
                    />
                    <span>8 - 10</span>
                  </label>
                </div>

                <fade-transition>
                  <div class="secundairy-filter__position" v-if="selectedYear !== '2018'">
                    <div class="secundairy-filter__title">
                      Positie t.o.v. voorafgaand jaar
                    </div>
                    <label class="secundairy-filter__rounds">
                      <input
                        ref="position-item-1-mobile"
                        name="positie"
                        type="checkbox"
                        @change="changeFacet('position', 's', 1, 'mobile')"
                      />
                      <span class="secundairy-filter__round secundairy-filter__round--high">
                        stijger
                      </span>
                    </label>
                    <label class="secundairy-filter__rounds">
                      <input
                        ref="position-item-2-mobile"
                        name="positie"
                        type="checkbox"
                        @change="changeFacet('position', 'd', 2, 'mobile')"
                      />
                      <span class="secundairy-filter__round secundairy-filter__round--low">
                        daler
                      </span>
                    </label>
                    <label class="secundairy-filter__rounds">
                      <input
                        ref="position-item-3-mobile"
                        name="positie"
                        type="checkbox"
                        @change="changeFacet('position', '=', 3, 'mobile')"
                      />
                      <span class="secundairy-filter__round secundairy-filter__round--same">
                        gelijk
                      </span>
                    </label>
                  </div>
                </fade-transition>
              </div>
            </div>

            <button class="secundairy-filter__reset" @click="removeFilters('mobile')">
              <template v-if="selectedYear === '2018'">
                <span>Filters wissen</span>
              </template>
              <template v-else>
                <span>Filters wissen</span>
              </template>
            </button>
          </div>
        </div>
        <button class="popup-content__button" @click="onClose">
          Bekijk
        </button>
      </div>
    </popup>

    <div v-if="summaryHidden" class="filter-options">
      <div v-show="!openPopup" class="filter-summary" @click="() => openPopup = true">
        <div class="filter-summary__body">
          <div class="filter-summary__content">
            <img src="@/assets/img/inwoners.svg" class="people" />
            {{ choseFilter }}
            <img src="@/assets/img/triangle-down.svg" class="triangle" />
          </div>
        </div>
      </div>

      <div class="filter-search">
        <search-bar />
      </div>
    </div>

    <div v-if="showSearchBar" class="search-desktop">
      <search-bar :auto-focus="true" @submit="showSearchBar = false" />
    </div>

    <div class="filter-bar">
      <div class="filter-bar__year">{{ selectedYear }}</div>

      <div class="filter-bar__container">
        <div class="filter-bar__facets">
          <img src="@/assets/img/inwoners.svg" />
          <facets-item
            :topic="['Inwoners']"
            :name="[' ']"
            type="radio"
            filter-type="RANGE"
            device="desktop"
            @filterChanged="onFilterChange"
          >
            <template slot="options">
              {{ filterBarData }}
            </template>
          </facets-item>
        </div>

        <div class="filter-bar__years">
          <controls-year-selector />
        </div>
      </div>

      <button class="filter-search-desktop" @click="showSearchBar = !showSearchBar">
        <search-icon class="filter-search-desktop__icon" />
        Zoek op gemeente
      </button>

      <button class="filter-bar__toggle" @click="toggleFilter">
        <img src="./assets/img/filter.svg" />
      </button>
    </div>

    <div v-if="!isMobile" class="secundairy-filter secundairy-filter--desktop">
      <div class="secundairy-filter__container">
        <div class="secundairy-filter__inbox">
          <div class="secundairy-filter__rapport">
            Rapportcijfer
            <label class="secundairy-filter__item">
              <input
                ref="rapport-item-1-desktop"
                name="rapport"
                type="checkbox"
                @change="changeFacet('rapport', [0, 5.5], 1)"
              />
              <span>0 - 5,5</span>
            </label>
            <label class="secundairy-filter__item">
              <input
                ref="rapport-item-2-desktop"
                name="rapport"
                type="checkbox"
                @change="changeFacet('rapport', [5.5, 6.5], 2)"
              />
              <span>5,5 - 6,5</span>
            </label>
            <label class="secundairy-filter__item">
              <input
                ref="rapport-item-3-desktop"
                name="rapport"
                type="checkbox"
                @change="changeFacet('rapport', [6.5, 8], 3)"
              />
              <span>6,5 - 8</span>
            </label>
            <label class="secundairy-filter__item">
              <input
                ref="rapport-item-4-desktop"
                name="rapport"
                type="checkbox"
                @change="changeFacet('rapport', [8, 10], 4)"
              />
              <span>8 - 10</span>
            </label>
          </div>

          <fade-transition>
            <div class="secundairy-filter__position" v-if="selectedYear !== '2018'">
              Positie t.o.v. voorafgaand jaar
              <label class="secundairy-filter__rounds">
                <input
                  ref="position-item-1-desktop"
                  name="positie"
                  type="checkbox"
                  @change="changeFacet('position', 's', 1)"
                />
                <span class="secundairy-filter__round secundairy-filter__round--high">stijger</span>
              </label>
              <label class="secundairy-filter__rounds">
                <input
                  ref="position-item-2-desktop"
                  name="positie"
                  type="checkbox"
                  @change="changeFacet('position', 'd', 2)"
                />
                <span class="secundairy-filter__round secundairy-filter__round--low">daler</span>
              </label>
              <label class="secundairy-filter__rounds">
                <input
                  ref="position-item-3-desktop"
                  name="positie"
                  type="checkbox"
                  @change="changeFacet('position', '=', 3)"
                />
                <span class="secundairy-filter__round secundairy-filter__round--same">gelijk</span>
              </label>
            </div>
          </fade-transition>
        </div>
      </div>

      <button class="secundairy-filter__reset" @click="removeFilters('desktop')">
        <img src="@/assets/img/filter-button.svg" class="filter" />
        <template v-if="selectedYear === '2018'">
          Filters wissen
        </template>
        <template v-else>
          Filters wissen
        </template>
      </button>
    </div>

    <summary-region @shown="summaryHidden = false" @hide="summaryHidden = true" />

    <div class="content">
      <div class="content__line --top" />
      <div class="content__box">
        <h1>Financi&euml;le stresstest</h1>
        <h1>Nederlandse gemeenten 2022</h1>
        <h2>Ontdek de scores per groottecategorie</h2>
      </div>
      <div class="content__line --bottom" />
    </div>

    <!-- <google-maps-download class="gm-download" /> -->

    <div class="info-boxes">
      <summary-info-box class="info-boxes__summary"/>

      <div class="download-box">
        <div class="download-box__content">
        Benieuwd naar diepgaande analyse van de financiële performance van de Nederlandse gemeenten?
        </div>
        <a href="https://go.bdo.nl/Benchmark-gemeenten-2022-ps-dzb-bm-gem-lo-22.html" target="_blank" class="download-box__button">
          Download benchmark gemeenten 2022
        </a>
      </div>
    </div>

    <div class="download-box-mobile">
      <a href="https://go.bdo.nl/Benchmark-gemeenten-2022-ps-dzb-bm-gem-lo-22.html" target="_blank" class="download-box-mobile__button">
        Download benchmark gemeenten 2022
      </a>
    </div>

    <transition name="fade" v-on:enter="hintTransitionEnter">
      <div v-if="hintBoxVisible" class="hint-box">
        <img class="hint-box__icon" src="@/assets/img/info.svg"/>
        <div class="hint-box__label">
          Klik op een gemeente en bekijk de scores
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import SearchIcon from '@atoms/search-icon';
import isMobile from './helpers/platform';

import FadeTransition from './helpers/transitions/fade.vue';

export default {
  name: 'App',

  components: {
    FadeTransition,
    SearchIcon,
  },

  data() {
    return {
      showSearchBar: false,
      openPopup: false,
      hintBoxVisible: false,
      facet: {},
      summaryHidden: true,
    };
  },

  computed: {
    ...mapState({
      selectedYear: (state) => state.rawData.year,
      counterIsRunning: (state) => state.infoBoxCounter.isRunning,
    }),

    ...mapGetters({
      statedFilters: 'filter/filters',
    }),

    isMobile() {
      return isMobile();
    },

    choseFilter() {
      return this.statedFilters?.Inwoners?.label;
    },

    filterBarData() {
      const currentFilterValue = this.statedFilters?.Inwoners?.value[0];
      return [
        {
          label: '< 25.000',
          value: [0, 25000],
          selected: currentFilterValue === '0,25000',
        },
        {
          label: '25.000 - 50.000',
          value: [25000, 50000],
          selected: currentFilterValue === '25000,50000',
        },
        {
          label: '50.000 - 100.000',
          value: [50000, 100000],
          selected: currentFilterValue === '50000,100000',
        },
        {
          label: '> 100.000',
          value: [100000, 20000000],
          selected: currentFilterValue === '100000,20000000',
        },
      ];
    },

    population() {
      switch (this.statedFilters?.Inwoners?.label) {
        case '< 25.000':
          return 'kleiner dan 25.000';

        case '25.000 - 50.000':
          return 'tussen 25.000 en 50.000';

        case '50.000 - 100.000':
          return 'tussen 50.000 en 100.000';

        case '> 100.000':
          return 'groter dan 100.000';

        default:
          return 'tussen 25.000 en 50.000';
      }
    },
  },

  methods: {
    onFilterChange({ initial }) {
      if (!initial) {
        this.$root.$emit('dataLayer/reset');
        this.$store.commit('infoBoxCounter/setContinueToNextState', false);
        this.$store.commit('infoBoxCounter/setActiveItem', null);
        this.$store.commit('infoBoxCounter/stop');
        // this.$store.commit('infoBoxCounter/start');
      }
    },

    removeFilters(device = 'desktop') {
      if (!Object.keys(this.facet).length) {
        return;
      }

      this.facet = {};

      Object.keys(this.$refs).forEach((ref) => {
        if (ref.indexOf(`-${device}`) === -1) {
          return;
        }

        if (this.$refs[ref].checked) {
          this.$refs[ref].checked = false;
        }
      });

      ['rapport', 'position'].forEach((key) => {
        this.$store.commit('filter/removeFacet', key);
      });
    },

    changeFacet(key, value, count, device = 'desktop') {
      if (!this.facet[key]) {
        this.facet[key] = value;

        this.$store.commit('filter/setFacet', { key, value });

        return;
      }

      if (
        this.facet[key] === value
        || JSON.stringify(this.facet[key]) === JSON.stringify(value)
      ) {
        this.facet[key] = null;

        this.$store.commit('filter/removeFacet', key);

        return;
      }

      Object.keys(this.$refs).forEach((ref) => {
        if (ref.indexOf(`${key}-item`) === -1) {
          return;
        }

        if (ref === `${key}-item-${count}-${device}`) {
          return;
        }

        this.$refs[ref].checked = false;
      });

      this.facet[key] = value;

      this.$store.commit('filter/setFacet', { key, value });
    },

    onClose() {
      this.closePopup();
    },

    toggleFilter() {
      const className = 'filter-open';
      const { body } = document;

      if (body.classList.contains(className)) {
        body.classList.remove(className);

        return;
      }

      body.classList.add(className);
    },

    closePopup() {
      this.openPopup = false;
    },

    toggleHintBox() {
      this.hintBoxVisible = !this.hintBoxVisible;
    },

    // Auto hide hint box after x seconds
    hintTransitionEnter() {
      const that = this;
      setTimeout(() => {
        that.hintBoxVisible = false;
      }, 3000);
    },
  },

  watch: {
    selectedYear() {
      this.removeFilters('desktop');
      this.removeFilters('mobile');

      this.$root.$emit('dataLayer/reset');
      this.$store.commit('infoBoxCounter/setContinueToNextState', false);
      this.$store.commit('infoBoxCounter/setActiveItem', null);
      this.$store.commit('infoBoxCounter/stop');
    },

    counterIsRunning(isRunning) {
      if (!isRunning) {
        this.toggleHintBox();
      }
    },
  },

  mounted() {
    document.addEventListener('click', () => {
      this.$root.$emit('dataLayer/reset');
      this.$store.commit('infoBoxCounter/setContinueToNextState', false);
      this.$store.commit('infoBoxCounter/setActiveItem', null);
      this.$store.commit('infoBoxCounter/stop');
      this.$root.$emit('dataLayer/set');
    });

    setTimeout(() => {
      document.body.classList.add('filter-open');
    }, 3000);
  },
};
</script>

<style lang="scss">
  // stylelint-disable selector-max-universal, jeroensmits/declaration-use-variable
  @font-face {
    font-family: 'Bliss 2';
    font-style: normal;
    font-weight: 900;
    src: url('assets/fonts/Bliss2-Bold.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Bliss 2';
    font-style: normal;
    font-weight: bold;
    src: url('assets/fonts/Bliss2-Medium.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Bliss 2';
    font-style: normal;
    font-weight: normal;
    src: url('assets/fonts/Bliss2-Light.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Bliss 2';
    font-style: normal;
    font-weight: 500;
    src: url('assets/fonts/Bliss2.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Bliss 2';
    font-style: normal;
    font-weight: 300;
    src: url('assets/fonts/Bliss2-ExtraLight.woff2') format('woff2');
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  body {
    @include font-size(theta);

    background-color: $color-grey;
    color: #231F20;
    font-family: $font-family-base;
    margin: 0;
    overflow: hidden;
    // overflow-y: auto;
  }

  @include mq($until: tablet) {
    .app {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  button {
    font-family: $font-family-base;
  }

  .list-title {
    @include font-size(epsilon);

    font-weight: 300;
    margin-bottom: $global-spacing-unit-threequarter;
  }

  .secundairy-filter {
    @include font-size(theta);

    align-items: center;
    background-color: $color-river-bed;
    bottom: 0;
    color: $color-white;
    display: flex;
    font-weight: normal;
    height: 53px;
    left: 0;
    position: absolute;
    transform: translateY(100%);
    transition: transform .75s;
    width: 100%;
    z-index: get-z-index();

    @include mq($until: tablet) {
      &--desktop {
        display: none;
      }
    }

    .filter-open & {
      transform: translateY(0);
    }

    &__container {
      margin: 0 auto;
      max-width: 826px;
      padding-left: $global-spacing-unit;
      padding-right: $global-spacing-unit;
      width: 100%;
    }

    &__inbox {
      display: flex;
    }

    &__rapport {
      align-items: center;
      display: flex;
      margin-left: -46px;
    }

    &__position {
      align-items: center;
      display: flex;
      margin-left: 30px;
    }

    &__reset {
      @include font-size(theta);

      align-items: center;
      background: $color-lynch;
      border: 0;
      border-radius: $global-radius-half;
      color: $color-white;
      cursor: pointer;
      display: flex;
      font-weight: 300;
      margin-right: 85px;
      outline: 0;
      padding: 4px 30px 4px 6px;
      width: 164px;

      &:hover {
        background-color: $color-shark;
      }

      img {
        margin-right: 29px;
      }
    }

    &__item, &__rounds {
      cursor: pointer;
      display: block;
      font-weight: 300;
      margin-left: $global-spacing-unit-half;
      position: relative;

      span {
        background-color: $color-lynch;
        border-radius: $global-radius-half;
        display: block;
        line-height: 28px;
        text-align: center;
        width: 63px;

        &:hover {
          background-color: $color-cerulean;
        }

        &.secundairy-filter__round {
          @include font-size(zero);

          align-items: center;
          border-radius: 50%;
          display: flex;
          flex-direction: column;
          height: 28px;
          justify-content: center;
          overflow: hidden;
          position: relative;
          text-indent: -999px;
          width: 28px;

          &--high::before {
            border-bottom: 9px solid $color-white;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            content: '';
            display: block;
            height: 0;
            width: 0;
          }

          &--low::before {
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 9px solid $color-white;
            content: '';
            display: block;
            height: 0;
            width: 0;
          }

          &--same {
            text-indent: 0;

            &::before {
              background-color: $color-white;
              content: '';
              display: block;
              height: 4px;
              margin-bottom: 3px;
              width: 12px;
            }

            &::after {
              background-color: $color-white;
              content: '';
              display: block;
              height: 4px;
              width: 12px;
            }
          }
        }
      }

      input {
        left: -9999px;
        position: absolute;

        &:checked + span {
          background-color: $color-cerulean;
        }
      }
    }

    @include mq($until: tablet) {
      border-radius: $global-radius;
      display: block;
      height: auto;
      padding: 12px;
      position: static;
      transform: translate(0);

      &__container {
        padding: 0;
      }

      &__inbox {
        display: block;
      }

      &__rapport {
        flex-wrap: wrap;
        margin-bottom: 15px;
        margin-left: 0;
      }

      &__position {
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 15px;
        margin-right: 0;
      }

      &__title {
        margin-bottom: 6px;
        text-align: center;
        width: 100%;
      }

      &__item {
        @include font-size(milli);

        margin-left: 8px;

        &:first-of-type {
          margin-left: 0;
        }

        span {
          width: 43px;
        }
      }

      &__reset {
        width: 100%;

        span {
          flex-grow: 1;
          text-align: center;
        }
      }
    }
  }

  .filter-bar {
    align-items: center;
    background-color: $color-white;
    bottom: 0;
    box-shadow: 0 5px 8px rgba($color-lynch, .63);
    display: flex;
    height: 70px;
    justify-content: flex-start;
    left: 0;
    margin-bottom: 0;
    position: absolute;
    transition: transform .75s;
    width: 100%;
    z-index: get-z-index();

    &__year {
      @include font-size(jumbo);

      background-color: $color-white;
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      flex-grow: 0;
      flex-shrink: 0;
      font-weight: 900;
      height: 48px;
      left: 50%;
      position: absolute;
      text-align: center;
      top: 0;
      transform: translate(-50%, -100%);
      width: 175px;

      &::before,
      &::after {
        bottom: 0;
        content: '';
        height: 10px;
        position: absolute;
        width: 20px;
      }

      &::before {
        border-radius: 0 0 9px 0;
        box-shadow: 9px 0 0 0 $color-white;
        left: -20px;
      }

      &::after {
        border-radius: 0 0 0 9px;
        box-shadow: -9px 0 0 0 $color-white;
        right: -20px;
      }
    }

    .filter-open & {
      transform: translateY(-53px);
    }

    &__container {
      display: flex;
      margin: 0 auto;
      max-width: 826px;
      padding-left: $global-spacing-unit;
      padding-right: $global-spacing-unit;
      transform: translateX(25px);
      width: 100%;
    }

    &__facets {
      align-items: center;
      display: flex;
    }

    &__years {
      margin-left: auto;
    }

    &__toggle {
      background: none;
      border: 0;
      cursor: pointer;
      margin-right: $global-spacing-unit-double;
      outline: 0;
      padding: 0;
    }

    img {
      float: left;
      height: 20px;
    }

    @include mq($until: tablet) {
      display: none;
    }
  }

  .filter-options {
    bottom: $global-spacing-unit-triple;
    left: 0;
    position: fixed;
    width: 100%;
    z-index: get-z-index();

    @include mq($from: tablet) {
      display: none;
    }
  }

  .filter-search {
    margin: 0 auto;
    margin-top: $global-spacing-unit-threequarter;
    width: 250px;
  }

  .filter-summary {
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: get-z-index();

    &__body {
      background-color: $color-grey;
      border-radius: $global-radius;
      box-shadow: 0 4px 10px rgba($color-silver, .5);
      overflow: hidden;
      width: 250px;
    }

    &__title {
      @include font-size(milli);

      background-color: $color-cerulean;
      color: $color-white;
      font-weight: bold;
      padding: $global-spacing-unit-quarter 0;
      text-align: center;
      text-transform: uppercase;
    }

    &__content {
      @include font-size(theta);

      background-color: $color-white;
      cursor: pointer;
      font-weight: 300;
      line-height: 26px;
      padding: 12px 15px;
      text-align: center;

      img.people {
        float: left;
        height: 28px;
      }

      img.triangle {
        float: right;
        margin-top: 10px;
      }
    }

    &__button {
      @include font-size(iota);

      background-color: $color-cerulean;
      border: 0;
      border-radius: $global-radius;
      color: $color-white;
      display: block;
      font-weight: 500;
      margin-top: $global-spacing-unit-threequarter;
      padding: $global-spacing-unit-quarter $global-spacing-unit-half;
      width: 100%;
    }
  }

  .search-desktop {
    background-color: rgba($color-dove-gray, .63);
    bottom: 70px;
    left: 0;
    padding: $global-spacing-unit-double 0;
    position: absolute;
    transition: transform .75s;
    width: 100%;
    z-index: get-z-index();

    .filter-open & {
      transform: translateY(-53px);
    }

    @include mq($until: tablet) {
      display: none;
    }
  }

  .filter-search-desktop {
    @include font-size(theta);

    align-items: center;
    background-color: $color-lynch;
    border: 0;
    border-radius: $global-radius-half;
    color: $color-white;
    cursor: pointer;
    display: flex;
    font-family: $font-family-base;
    font-weight: 300;
    margin-right: $global-spacing-unit;
    outline: none;
    padding: $global-spacing-unit-quarter $global-spacing-unit-half;
    width: 164px;

    &__icon {
      fill: $color-white;
      margin-right: $global-spacing-unit-quarter;
      width: 12px;
    }

    @include mq($until: tablet) {
      display: none;
    }
  }

  .content {
    bottom: 0;
    display: flex;
    flex-direction: column;
    left: $global-spacing-unit * 5;
    pointer-events: none;
    position: absolute;
    top: 0;
    z-index: get-z-index('.content');

    @include mq($until: tablet) {
      left: $global-spacing-unit-double;
      z-index: get-z-index('.content-mobile');
    }

    &__line {
      background-color: $color-cerulean;
      width: 20px;

      &.\--top {
        height: 66px;

        @include mq($until: 768) {
          display: none;
        }
      }

      &.\--bottom {
        flex-grow: 1;
        position: relative;

        @include mq($until: 768) {
          display: none;
        }
      }
    }

    &__box {
      max-width: 350px;
      padding: $global-spacing-unit-triple 0;
      position: relative;
      z-index: get-z-index('.content-mobile');

      @include mq($until: tablet) {
        max-width: 250px;
        padding: $global-spacing-unit-oneandahalf 0;
      }

      h1 {
        @include font-size(zeta, $iota-line-height);

        -webkit-text-size-adjust: none;
        background-color: $color-cerulean;
        border-radius: $global-radius;
        color: $color-white;
        display: inline-block;
        font-weight: normal;
        margin: 0 0 $global-spacing-unit-half -20px;
        padding: $global-spacing-unit-quarter $global-spacing-unit-half;
        text-size-adjust: none;
        text-transform: uppercase;
        z-index: get-z-index('.content');

        @include mq($until: tablet) {
          @include font-size(theta, 16px);
        }
      }

      h2 {
        @include font-size(alpha, $beta-line-height);

        -webkit-text-size-adjust: none;
        font-weight: 300;
        margin: 0 0 0 -20px;
        text-size-adjust: none;
        z-index: get-z-index('.content');

        @include mq($until: tablet) {
          display: none;
        }
      }

      &::before {
        border-bottom: solid 7px transparent;
        border-left: solid 10px $color-cerulean;
        border-right: solid 10px transparent;
        border-top: solid 7px $color-cerulean;
        content: '';
        position: absolute;
        top: 0;

        @include mq($until: 768) {
          display: none;
        }
      }

      &::after {
        border-bottom: solid 7px $color-cerulean;
        border-left: solid 10px transparent;
        border-right: solid 10px $color-cerulean;
        border-top: solid 7px transparent;
        bottom: 0;
        content: '';
        position: absolute;

        @include mq($until: 768) {
          display: none;
        }
      }
    }
  }

  .info-boxes {
    bottom: 190px;
    display: flex;
    pointer-events: none;
    position: fixed;
    width: 100%;
    z-index: get-z-index();

    @include mq($until: tablet) {
      bottom: 190px;
    }

    &__summary {
      left: 50%;
      position: absolute;
      transform: translateX(-50%) translateY(-100%);
    }
  }

  .download-box {
    @include font-size(iota, 16px);

    background-color: $color-white;
    border-radius: $global-radius;
    box-shadow: 0 2px 6px rgba($color-silver, .5);
    padding: $global-spacing-unit-half;
    pointer-events: initial;
    position: absolute;
    right: 80px;
    transform: translateY(-100%);
    width: 320px;

    &__content {
      margin-bottom: $global-spacing-unit-half;
    }

    &__button {
      @include font-size(milli, 13px);

      background-color: $color-cerulean;
      border-radius: $global-radius;
      color: $color-white;
      display: block;
      font-weight: normal;
      padding: $global-spacing-unit-quarter $global-spacing-unit-half;
      text-align: center;
      text-decoration: none;
      text-transform: uppercase;
    }

    @include mq($until: tablet) {
      display: none;
    }
  }

  .download-box-mobile {
    bottom: 0;
    display: none;
    padding: 0;
    position: fixed;
    right: 0;
    width: 100%;

    @include mq($until: tablet) {
      display: block;
    }

    &__button {
      @include font-size(milli, 13px);

      background-color: $color-cerulean;
      color: $color-white;
      display: block;
      font-weight: bold;
      padding: $global-spacing-unit-half;
      text-align: center;
      text-decoration: none;
      text-transform: uppercase;
    }
  }

  .hint-box {
    align-items: center;
    background-color: $color-white;
    border-radius: $global-radius;
    box-shadow: 0 2px 6px rgba($color-silver, .5);
    display: flex;
    flex-direction: row;
    left: 50%;
    padding: $global-spacing-unit-half;
    position: absolute;
    top: 50%;
    transform: translateX(-50%);
    z-index: get-z-index();

    @include mq($until: tablet) {
      top: 280px;
    }

    &__icon {
      align-self: center;
    }

    &__label {
      @include font-size(milli);

      font-weight: 500;
      padding-left: $global-spacing-unit-half;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .gm-download {
    left: 0;
    position: absolute;
    top: 0;
  }

  .zoom-controls {
    bottom: 25px;
    left: 137px;
    position: absolute;
    transition: transform .75s;

    .filter-open & {
      transform: translateY(-53px);
    }

    @include mq($until: desktop) {
      display: none;
    }
  }

  .popup-content {
    &__facets {
      text-align: center;

      img {
        height: 20px;
      }
    }

    &__years {
      display: flex;
      justify-content: center;
      margin-bottom: 32px;
      margin-top: 17px;
    }

    &__button {
      @include font-size(theta);

      background-color: $color-cerulean;
      border: 0;
      border-radius: $global-radius;
      color: $color-white;
      margin-top: 17px;
      padding: 6px 15px;
      width: 100%;
    }
  }
</style>
